export default __webpack_public_path__ + "static/media/hotAir.a05bcf05.png";